module.exports = __webpack_public_path__ + "img/qiyeweixin.e60fca73.png";